module.exports = __webpack_public_path__ + "img/apidays-hongkong-2023-agenda-0831.2d11ff92.png";